var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"justify":"center"}},[_c('v-btn',{staticClass:"disable-events",attrs:{"color":"green lighten-1","dark":""}},[_vm._v("\n    Victory\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }